import React from "react";

import Form from "react-bootstrap/Form";
import { US_STATES } from "@/constants/us-state";

const SelectStateInput = ({
  name = "state",
  placeholder = "State/Province",
  ...props
}) => {
  return (
    <div>
      <Form.Select name={name} aria-label="State/Province" {...props}>
        <option>{placeholder}</option>
        {US_STATES.map((state, x) => (
          <option value={state.abbreviation} key="x">
            {state.name}
          </option>
        ))}
      </Form.Select>
    </div>
  );
};

SelectStateInput.propTypes = {};

export default SelectStateInput;
